import { render } from "./supplierlist.vue?vue&type=template&id=6c1de3aa"
import script from "./supplierlist.vue?vue&type=script&lang=js"
export * from "./supplierlist.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__